import {InjectionToken} from '@angular/core';

export interface MenuItem {
    label: string;
    icon: string;
    link?: string;
    permission?: string;
    hasAppProperty?: string;
    isRecentlyUsed?: boolean;
    items?: MenuItem[];
    externalRedirect?: boolean;
    toShow?: boolean;
    hasDynamicChildren?: boolean;
    developMode?: boolean;
}

export interface MxNavigationMenuElementsService {
    getMenuElements(): MenuItem[];
}

export const MX_NAVIGATION_MENU_ELEMENTS_TOKEN = new InjectionToken<MxNavigationMenuElementsService>('MX_NAVIGATION_MENU_ELEMENTS_TOKEN');
